import React from 'react';

import Icon from './Icon';

function BlockNumbers({ section }) {
  const numbers = section?.references[0]?.numbers;
  return (
    <>
      {numbers && (
        <div className="block-numbers">
          {numbers?.map((number) => (
            <div key={number.id} className="number">
              {number.icon && (
                <div className="number__icon">
                  <Icon icon={number.icon} />
                </div>
              )}
              <p className="title">{number.title}</p>
              <p className="body --upper --small">{number.description}</p>
            </div>
          ))}
        </div>
      )}
    </>
  );
}

export default BlockNumbers;
